import React from 'react';
import './core-values.css';

const valuesData = [
    { id: 1, name: "Integrity & Trust", icon: "🤝", description: "Acting ethically and building confidence in every decision.", type: 'odd' },
    { id: 2, name: "Innovation First", icon: "💡", description: "Challenging the status quo to create market-leading solutions.", type: 'even' },
    { id: 3, name: "Client-Centricity", icon: "🎯", description: "Placing client success at the core of our operations and strategy.", type: 'odd' },
    { id: 4, name: "Accountability", icon: "🛡️", description: "Taking full ownership of results, successes, and failures.", type: 'even' },
    { id: 5, name: "Collaborative Growth", icon: "🌱", description: "Fostering an environment where diverse teams achieve collective excellence.", type: 'odd' },
];

const SkewedFocusItem = ({ data, index }) => (
    <div className={`focus-item item-${data.type}`} data-aos="fade-up" data-aos-delay={index * 120}>
        <div className="skew-panel">
            <div className="skew-content">
                <div className="focus-icon">{data.icon}</div>
                <h3 className="focus-title">{data.name}</h3>
                <p className="focus-description">{data.description}</p>
            </div>
        </div>
        <div className="connector-pin"></div>
    </div>
);

const CoreValuesSection = () => {
    return (
        <section className="core-values-container">
            <div className="background-cut"></div>

             <h2 className="display-4 core-title mb-2 text-dark">
                    Our Core <span className="core-secondary-info"> Values and Culture</span>
                </h2>
            <p className="section-subheader" data-aos="fade-up" data-aos-delay="100">
                The Foundational Focus Array Guiding Our Future.
            </p>

            <div className="focus-array-wrapper">
                {valuesData.map((data, index) => (
                    <SkewedFocusItem key={data.id} data={data} index={index} />
                ))}
            </div>
        </section>
    );
};

export default CoreValuesSection;
